import React, { useState } from "react";
import Select from "react-select";
const SelectDropDown2 = ({ options, setSelectedOptionCategory,styles,deafaultV }) => {
    // console.log(options)
    const [selectedOption, setSelectedOption] = useState(deafaultV);
    selectedOption != null && setSelectedOptionCategory(selectedOption);
    return <Select styles={styles} placeholder="---Select---" isClearable defaultValue={selectedOption} onChange={setSelectedOption} options={options} />;
  };
  
  export default SelectDropDown2;